import React, { useRef, useState } from 'react'
import LeftControl from '../../Components/LeftControl'
import { Button, Divider, Form, Input, Select, Table, Typography, message, Modal, DatePicker, Checkbox } from 'antd'
import { Grid } from '@material-ui/core'
import PageHeader from '../../Components/PageHeader'
import { useHistory } from "react-router-dom";
import TableFilters from '../../Components/Locomotive/TableFilters'
import services from '../../Services'
import { useEffect } from 'react'
import moment from 'moment'
import { seriliazeParams } from '../../helpers/seriliazeParams'
import { showText } from '../../helpers/textValidation'
import { exportWorkOrders, getAllLocomotive, getAllLocomotiveTicketSources, getAllWorkOrders, getDatePicker, getDatePickerUpdated, getLocomotiveCloseoutReason, updateLocomotiveTicket, workCompletedTable, workCompletedTableExport } from '../../Services/LocomotiveServices'
import { TableDeleteDataLocomotive, TableWoDelete, get_site_listing } from '../../Services/employee'
import Services from '../../Services';
import PgDynamicTable2 from '../../Components/TableComponents/pgDynamicTable2'
import ModalDeleteWoTable from '../../Components/Modals/ModalDeleteWoTable'
import roleManager from '../../Components/roles'
import { Colors } from '../../helpers/Colors'
import ModalDeleteWoTableLocomotive from '../../Components/Modals/ModalDeleteWoTableLocomotive'
import { Category, CheckBox } from '@material-ui/icons'
import PageLayout from '../../Components/LayoutComponents/PageLayout'

const { hr } = services


const LocomotiveWorkOrders = () => {
    const { Text } = Typography;

    const selectRef = useRef();
    const {
        employee,
        Storage
    } = Services;

    const [edit, setEdit] = useState(false)
    const [Data, setData] = useState()
    const [closeComments, setCloseComments] = useState([])
    const [SwitchRadio, setSwitchRadio] = useState(true)
    const [sourceData, setSourceData] = useState([])
    const [equipId, setEquipId] = useState([])
    const [Count, setCount] = useState()
    const [location, setLocation] = useState([])

    const [equipId2, setEquipId2] = useState()
    const [LocationId, setLocationId] = useState()
    const [sourceID, setSourceID] = useState()
    const [RequestedForId, setRequestedForId] = useState()
    const [selectedAssignTo, setSelectedAssignTo] = useState()
    const [selectedOpen, setSelectedOpen] = useState(null)
    const [showDeleteWo, setShowDeleteWo] = useState();
    const [isModalOpenDeleteTable, setIsModalOpenDeleteTable] = useState(false);
    const [apiData, setApiData] = useState(null);
    const id = location?.state?.id;
    const [isModalOpenCompleted, setIsModalOpenCompleted] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
    const [isScheduleRepairsModalOpen, setIsScheduleRepairsModalOpen] = useState(false);

    const [selectedDate, setSelectedDate] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [tableDataUpdated, setTableDataUpdated] = useState([]);

    const [modalVisible, setModalVisible] = useState(false); // State for modal visibility
    const [isTaskChecked, setIsTaskChecked] = useState(false);
    const [isStatusChecked, setIsStatusChecked] = useState(false);
    const [form] = Form.useForm()

    const handleModalOpen = (record) => {

        form.setFieldsValue({
            PartType: record?.PartType,
            PartNbr: record?.PartNbr,
            PartSerialNbr: record?.PartSerialNbr
        })
        setModalVisible(true);
    };

    const handleModalClose = () => {
        setModalVisible(false);
    };

    const handleOk = async () => {
        if (!selectedDate) {
            // If date is getemployeecontdata selected, show an alert and return without making the API call
            message.destroy()
            message.error('Please select a date');
            return;
        }
        if (selectedDate) {
            try {
                const query = { date: selectedDate.format('MM/DD/YYYY') };
                const response = await getDatePicker({ query });
                // API call successful, open the second modal or perform any other actions
                setIsModalOpen(false);
                setIsSecondModalOpen(true);
                setPagination(prevPagination => ({
                    ...prevPagination,
                    current: 1,
                }));
                setApiData(response?.data);

                setTableData(response?.data)

            } catch (error) {
                // Handle API error
                message.error('Error saving data. Please try again.');
            }
        }
    };



    const yourColumnsModal2 = [
        {
            title: 'SCH REP DATE',
            dataIndex: 'unit',
            key: 'unit',
            render: (text, record) => {

                const dateScheduled = record?.ScheduleDate;
                const formattedDate = dateScheduled
                    ? moment.utc(dateScheduled)?.format('MM-DD-YYYY')
                    : 'N/A';
                if (apiData?.task == true) {


                    return (
                        <div>
                            {record?.EquipWOTaskIPs.map(task => (
                                <div key={task.id}>
                                    <p>{formattedDate}</p>
                                </div>
                            ))}
                        </div>
                    );
                }
                else {
                    return <p>{formattedDate}</p>;

                }
            },
        },

        {
            title: 'UNIT NUMBER',
            dataIndex: 'unit',
            key: 'unit',
            render: (text, record) => {
                if (apiData?.task == true) {
                    return (
                        <div>
                            {record?.EquipWOTaskIPs.map(task => (
                                <div key={task.id}>
                                    <p>{(record?.EquipMaster?.EquipUID || 'N/A')}</p>
                                </div>
                            ))}
                        </div>
                    );
                }
                else {
                    return <p>{(record?.EquipMaster?.EquipUID || 'N/A')}</p>;
                }
            },
        },

        {
            title: 'Location ',
            dataIndex: 'unit',
            key: 'unit',
            render: (text, record) => {
                if (apiData?.task == true) {

                    return (
                        <div>
                            {record?.EquipWOTaskIPs.map(task => (
                                <div key={task.id}>
                                    <p>{(record?.TGSLocation?.Abv || 'N/A')}</p>
                                </div>
                            ))}
                        </div>
                    );
                }
                else {
                    return <p>
                        {record?.TGSLocation?.Abv || 'N/A'}
                    </p>

                }
            },
        },
        {
            title: 'LOCO STATUS',
            dataIndex: 'repairsMade',
            key: 'repairsMade',
            render: (text, record) => {
                if (apiData?.task == true) {
                    return (
                        <div>
                            {record?.EquipWOTaskIPs.map(task => (
                                <div key={task.id}>
                                    <p>{(record?.EquipMaster?.status?.IS_OS_Code || 'N/A')}</p>
                                </div>
                            ))}
                        </div>
                    );
                }
                else {
                    return <p>{(record?.EquipMaster?.status?.IS_OS_Code || 'N/A')}</p>;
                }
            },

        },
        {
            title: 'REPAIRS NEEDED',
            dataIndex: 'repairsMade',
            key: 'repairsMade',
            render: (text, record) => {
                if (apiData?.task == true) {
                    return (
                        <div>
                            {record?.EquipWOTaskIPs.map(task => (
                                <p key={task.id}>{task?.EquipWOTaskDD?.Task || 'N/A'}</p>
                            ))}
                        </div>
                    );
                }
                else {
                    return <p>{record?.Ticket?.TicketCategory?.name || 'N/A'}</p>;

                }
            },
        },



        {
            title: 'WO_ID',
            dataIndex: 'WO_ID',
            key: 'WO_ID',
            render: (text, record) => {
                if (apiData?.task == true) {

                    return (
                        <div >
                            {record?.EquipWOTaskIPs.map(task => (
                                <div key={task.id} style={{ paddingBottom: '14px' }}>
                                    {record?.id ? (
                                        <a
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => history.push('/Locomotive-work-order-edit', { id: record?.id })}
                                        >
                                            {record?.id}
                                        </a>
                                    ) : (
                                        '-'
                                    )}
                                </div>
                            ))}
                        </div>
                    );
                }
                else {
                    return record?.id ? (
                        <div style={{ paddingBottom: '14px' }}>

                            <a
                                style={{ cursor: 'pointer' }}
                                onClick={() => history.push('/Locomotive-work-order-edit', { id: record?.id })}
                            >
                                {record?.id}
                            </a >
                        </div>
                    ) : (
                        '-'
                    )
                }
            },
        },

        {
            title: 'ASSIGNED TO',
            dataIndex: 'CauseCode',
            key: 'CauseCode',
            render: (text, record) => {

                if (apiData?.task == true) {
                    return (
                        <div>
                            {record?.EquipWOTaskIPs.map(task => (
                                <p key={task.id}>
                                    {task?.AssignedtoContractor
                                        ? contractormap(task?.AssignedtoContractor)
                                        : task?.AssignedTo
                                            ? (task?.AssignedTo?.fullName || (task?.AssignedTo?.firstName + " " + task?.AssignedTo?.lastName))
                                            : task?.assignedToType === 'employee' ? '' : 'N/A'
                                    }
                                </p>
                            ))}
                        </div>
                    );
                }
                else {
                    return <p>{(
                        record?.Assignedto
                            ? (record?.Assignedto?.fullName || (record?.Assignedto?.firstName + " " + record?.Assignedto?.lastName))
                            : record?.AssignedtoContractor
                                ? contractormap(record?.AssignedtoContractor)
                                : record.assignedToType == 'employee' ? '' : undefined
                    )}</p>;
                }

            },
        },
    ];

    const yourColumns = [
        {
            title: 'UNIT NUMBER',
            dataIndex: 'unit', // Replace with the actual data field
            key: 'unit',
            render: (text, record) => {
                return <p>{(record?.EquipUID || 'N/A')}</p>;
            },
        },
        {
            title: 'LOCATION',
            dataIndex: 'location', // Replace with the actual data field
            key: 'location',
            render: (text, record) => {
                return <p>{record?.Location || 'N/A'}</p>;
            },
        },
        {
            title: 'REPAIRS NEEDED',
            dataIndex: 'repairsNeeded', // Replace with the actual data field
            key: 'repairsNeeded',
            render: (text, record) => {
                return <p>{record?.RepairNeeded || 'N/A'}</p>;
            },
        },

        {
            title: 'REPAIRS MADE',
            dataIndex: 'repairsMade', // Replace with the actual data field
            key: 'repairsMade',

            render: (text, record) => {
                return <p><span>
                    {record?.RepairMade} {record?.PartNbr && (
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                handleModalOpen(record);
                            }}
                        >
                            ({record?.PartNbr})
                        </a>
                    )}
                </span></p>;
            },
        },
        {
            title: 'DATE COMPLETED',
            dataIndex: 'dateCompleted', // Replace with the actual data field
            key: 'dateCompleted',
            render: (text, record) => {

                const originalDateString = record?.DateCompleted;
                const formattedDate = originalDateString
                    ? moment.utc(originalDateString).format('MM-DD-YYYY')
                    : 'N/A';

                return <p>{formattedDate}</p>;
            },


        },
        {
            title: 'DWELL',
            dataIndex: 'DWELL', // Replace with the actual data field
            key: 'DWELL',
            render: (text, record) => {
                const { WorkScheduled, WorkCompleted } = record;

                if (WorkScheduled && WorkCompleted) {
                    const dwellDays = Math.ceil(Math.abs(new Date(WorkCompleted) - new Date(WorkScheduled)) / (1000 * 60 * 60 * 24));
                    return <p>{dwellDays}</p>;
                } else {
                    return <p>N/A</p>;
                }
            },
        },
        {
            title: 'REPAIRED BY',
            dataIndex: 'repairedBy', // Replace with the actual data field
            key: 'repairedBy',
            render: (text, record) => {
                return <p>{(record?.RepairedBy || 'N/A')}</p>;
            },
        },

        {
            title: 'WO_ID',
            dataIndex: 'ref',
            key: 'ref',
            render: (text, record) => {
                return record?.WOID ? (
                    <a
                        style={{ cursor: 'pointer', marginTop: '-10px' }}
                        onClick={() => history.push('/Locomotive-work-order-edit', { id: record.WOID })}
                    >{record.WOID}
                    </a >
                ) : (
                    '-'
                )
                // record?.WOID || 'N/A'

            },
        },
        {
            title: 'Cause Code',
            dataIndex: 'CauseCode', // Replace with the actual data field
            key: 'CauseCode',
            render: (text, record) => {
                return <p>{(record?.CauseCode || 'N/A')}</p>;
            },
        },
    ];




    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleExportDeleteTask = async () => {

        try {
            const query = { date: selectedDate.format('YYYY/MM/DD') };

            const response = await workCompletedTable({ query });
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `WorkCompleted.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data:', error);
        }
    }

    const handleCancel = () => {
        setIsModalOpen(false);
        setSelectedDate(undefined);

    };


    const handleSecondModalOk = () => {
        setIsSecondModalOpen(false);
    };

    const handleSecondModalCancel = () => {
        setIsSecondModalOpen(false);
        setSelectedDate(undefined);

    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    // New Modal completed //

    const showModalCompleted = () => {
        setIsModalOpenCompleted(true);
    };
    const handleOkCompleted = async () => {
        if (!selectedDate) {
            message.destroy()
            message.error('Please select a date');
            return;
        }

        if (selectedDate) {
            try {
                const selectedDateFormatted = selectedDate.format('YYYY/MM/DD');
                const taskChecked = document?.getElementById("taskCheckbox")?.checked;
                const statusChecked = document?.getElementById("statusCheckbox")?.checked;

                const query = {
                    date: selectedDateFormatted,

                };
                const payload = {
                    task: taskChecked,
                    status: statusChecked
                }
                const response = await getDatePickerUpdated({ query, payload });
                setIsModalOpenCompleted(false);
                setPagination(prevPagination => ({
                    ...prevPagination,
                    current: 1,
                }));
                setApiData(response?.data);
                setIsScheduleRepairsModalOpen(true);

                setTableDataUpdated(response?.data?.workorders)
            } catch (error) {
                message.error('Error saving data. Please try again.');
            }
        }
    };
    const handleCancelCompleted = () => {
        setSelectedDate(undefined);
        setIsModalOpenCompleted(false);
    };


    const handleScheduleRepairsModalOk = () => {
        setIsScheduleRepairsModalOpen(false);
    };

    const handleScheduleRepairsModalCancel = () => {
        setSelectedDate(undefined);

        setIsScheduleRepairsModalOpen(false);
    };




    const handleExportDeleteTaskUpdated = async () => {

        try {
            const taskChecked = apiData?.task
            const statusChecked = apiData?.status
            const query = {
                date: selectedDate.format('YYYY/MM/DD'),
            };
            const payload = {
                tasks: taskChecked,
                status: statusChecked
            }
            const data = {
                payload, query
            }

            const response = await workCompletedTableExport(data);
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `WorkScheduled.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data:', error);
        }
    }




    const states = {
        equipId: equipId2, setEquipId: setEquipId2,
        LocationId, setLocationId,
        sourceID, setSourceID,
        RequestedForId, setRequestedForId,
        selectedAssignTo, setSelectedAssignTo,
        selectedOpen, setSelectedOpen
    }


    const [pagination, setPagination] = useState({
        offSet: 0,
        limit: 25,
    })
    const [flag, setflag] = useState(false)
    const history = useHistory()
    const [EmployeeContListData, setEmployeeContListData] = useState([])
    const [EmployeeListData, setEmployeeListData] = useState([])

    const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
    const DeleteTablehandleOk = () => {
        setIsModalOpenDeleteTable(false);
    };
    const DeleteTablehandleCancel = () => {
        setIsModalOpenDeleteTable(false);
    };
    const fetchData = async (LocationId, equipId, SwitchStatus = null, employeeID, sourceID, AssignedToId, toggleState) => {
        let params = '?'.concat(seriliazeParams({ offset: pagination?.offSet, limit: pagination?.limit, WoLocation: LocationId, EquipID: equipId, CreatedBy: employeeID, TicketSourceId: sourceID, Status: SwitchStatus, AssignedToId: AssignedToId, Closed: toggleState }))
        let response = await getAllWorkOrders({ params });
        if (response?.httpStatus === 200) {
            const { data } = response;
            setData(data?.rows);
            setCount(data?.rows.length)
        }
    }
    const exportLocomotiveSheet = async (LocationId, equipId, SwitchStatus = 1, employeeID, sourceID, AssignedTo, toggleState) => {
        let params = '?'.concat(seriliazeParams({ offset: pagination?.offSet, limit: pagination?.limit, WoLocation: LocationId, EquipID: equipId, CreatedBy: employeeID, TicketSourceId: sourceID, Status: SwitchStatus, AssignedTo: AssignedTo, Closed: toggleState }))
        const result = await exportWorkOrders(({ params, }))
        const blob = new Blob([result], { type: 'text/csv' });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'LocomotiveWorkOrders.csv';
        link.click();
        window.URL.revokeObjectURL(blobUrl);
    }
    const getFilterDataQuipId = async () => {
        const result = await getAllLocomotive()
        if (result?.httpStatus === 200) {
            const data = result?.data.map((item, index) => {
                return {
                    label: item?.EquipUID,
                    value: item?.id
                }
            })
            setEquipId(data)

        }
    }
    const getCloseOutComments = async () => {
        const result = await getLocomotiveCloseoutReason(4)
        if (result?.httpStatus === 200) {
            const data = result?.data.map((item, index) => {
                return {
                    label: item?.CloseType,
                    value: item?.id
                }
            })
            setCloseComments(data)
        }
    }
    const getSiteLocation = async () => {
        const result = await get_site_listing()
        if (result?.httpStatus === 200) {
            const data = result?.data?.map((item, index) => {
                return {
                    label: item?.title,
                    value: item?.id
                }
            })
            setLocation(data)

        }
    }
    const contractormap = (data) => {
        let {
            firstName,
            lastName,
            Company
        } = data;

        let output = '';

        if (Company)
            output = Company;

        if (Company && firstName && lastName)
            output = output + "-"

        if (firstName && lastName)
            output = `${output} ${firstName} ${lastName[0]}.`

        return output;
    };


    useEffect(() => {

        let last_route = localStorage.getItem('last_route')
        let existingFilters = JSON.parse(localStorage.getItem('LocoWO_Filters'))
        let map = {
            equipID: setEquipId2,
            locationID: setLocationId,
            requestedForID: setRequestedForId,
            AssignedToId: setSelectedAssignTo,
            source: setSourceID,
            status: setSelectedOpen,


        }
        if (existingFilters && last_route == '/Locomotive-work-order-edit')
            Object?.keys(existingFilters)?.forEach((key) => {
                if (existingFilters[key])
                    map[key] && map[key](existingFilters[key])
            })
        else
            localStorage.removeItem('LocoWO_Filters')

    }, [])

    const handleNavigation = (id) => {

        localStorage.setItem('LocoWO_Filters',
            JSON.stringify({
                equipID: equipId2,
                locationID: LocationId,
                source: sourceID,
                requestedForID: RequestedForId,
                AssignedToId: selectedAssignTo,
                status: selectedOpen
            }))
        history.push(`/Locomotive-work-order-edit`, { id })

    }
    const getCategory = (category, comment) => {
        if (category === 'Other Mechanical Issue') {
            category = 'OTH :';

            if (comment) {
                category += ` ${comment.substring(0, 25)}`;
            }
        }
        return category;
    }

    let table = {
        header: [
            "WO ID",
            "Equip ID",
            "Location",
            "Created By",
            "Date Opened",
            "Days Open",
            "Ticket Category",
            "Status",
            "Assigned To",
            "View",
        ],
        rows: Data?.map((item, index) => {
            const createdAt = moment(item?.createdAt)?.startOf('day');
            const currentDate = moment()?.startOf('day');
            const daysOpen = currentDate?.diff(createdAt, 'days');
            const isClosed = item?.Status === 'Closed';

            return [
                showText(item?.id),
                showText(item?.EquipMaster?.EquipUID),
                showText(item?.TGSLocation?.name),
                showText(item?.Createdby?.firstName + " " + item?.Createdby?.lastName),
                showText(moment?.utc(item?.createdAt)?.format('MM-DD-YYYY')),
                showText(daysOpen),
                getCategory(item?.Ticket?.TicketCategory?.name, item?.Ticket?.comment),
                showText(item?.Status),
                showText(item?.AssignedtoContractor ? contractormap(item.AssignedtoContractor) : item?.Assignedto ? item.Assignedto.firstName + " " + item.Assignedto.lastName : "N/A"),
                <Button className={isClosed ? "ViewIconNew" : "ViewIcon"} onClick={() => handleNavigation(item?.id)}>
                    <p></p>
                </Button>
            ]
        })
    }
    const getEmployeeContData = async () => {
        let result = await employee.AssignTo()
        if (result?.httpStatus === 200) {
            const data = result?.data.map((item, index) => {
                return {
                    label: `${item?.firstName} ${item?.lastName}`,
                    value: item?.id
                }
            })
            setEmployeeContListData(data)
        }
    }

    const getEmployeeData = async () => {
        let result = await employee.get_employee_listing_not_Terminated()
        if (result?.httpStatus === 200) {
            const data = result?.data.map((item, index) => {
                return {
                    label: `${item?.firstName} ${item?.lastName}`,
                    value: item?.id
                }
            })
            setEmployeeListData(data)
        }
    }

    const CloseOutCommentChange = async (id, commentId) => {
        const data = {
            TicketCloseId: commentId,
            close: true
        }
        const result = await updateLocomotiveTicket(id, data)
        if (result?.httpStatus == 200) {
            message.success('Successfully Updated!')
            setflag(!flag)
        }
    }
    const getAllTicketSource = async () => {
        const result = await getAllLocomotiveTicketSources()
        if (result?.httpStatus === 200) {
            setSourceData(result?.data)
        }
    }

    const resetCheckboxStates = () => {
        setIsTaskChecked(false);
        setIsStatusChecked(false);
    };


    useEffect(() => {
        getFilterDataQuipId()
        getSiteLocation()
        getCloseOutComments()
        getAllTicketSource()
        getEmployeeContData()
        getEmployeeData()
        resetCheckboxStates()
    }, [])

    return (
        <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Locomotive Work Orders</Grid>
                <div style={{ textAlign: 'right', marginTop: '10px' }}>
                    {roleManager("LocomotiveWorkOrder", "sections", "work_order_edits") ?
                        <Button style={{ background: 'white', color: '#2963ad', fontWeight: 'bold', borderRadius: '10px', border: '1px solid #BDBDBD', marginRight: '10px' }} onClick={showModal}>
                            Work Completed
                        </Button>
                        : ''}
                    <Button style={{ background: 'white', color: '#2963ad', fontWeight: 'bold', borderRadius: '10px', border: '1px solid #BDBDBD' }} onClick={showModalCompleted}>
                        Scheduled Work
                    </Button>
                </div>
                <div>
                    <TableFilters
                        mode="workorder"
                        exportData={exportLocomotiveSheet}
                        pagination={pagination}
                        edit={edit}
                        flag={flag}
                        setEdit={setEdit}
                        setSwitchRadio={setSwitchRadio}
                        callApi={fetchData}
                        states={states}
                        options={
                            {
                                searchBar: false,
                                moreFilter: true,
                                locationData: { data: location },
                                equipIdData: { data: equipId },
                                sourceData: { data: sourceData },
                                employeeData: { data: EmployeeListData },
                                employeeContData: { data: EmployeeContListData }

                            }
                        }
                        deleteBtn={
                            roleManager('LocomotiveWorkOrder', 'sections', 'DeleteListSheet') && showDeleteWo?.length !== 0 ? <div style={{ display: 'flex', flexDirection: 'row-reverse', marginRight: '10px' }}>
                                <Button style={{ background: 'white', color: Colors.mainBlue, borderRadius: '10px', fontWeight: "800", height: "35px", }} onClick={() => setIsModalOpenDeleteTable(true)}>Deleted Tasks</Button>
                            </div> : ''
                        }
                    />
                </div>
                <div>

                    <ModalDeleteWoTableLocomotive
                        handleOk={DeleteTablehandleOk}
                        handleCancel={DeleteTablehandleCancel}
                        isModalOpen={isModalOpenDeleteTable}
                        apiData={apiData}
                        defaultOption={'7'} />
                </div>
                <div style={{}}>
                    <PgDynamicTable2 tableData={table} setPagination={setPagination} pagination={pagination} edit={edit} count={Count} />
                </div>

            </Grid>

            <Modal
                title={<span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Date Work Completed</span>}


                visible={isModalOpen}
                onOk={handleOk}
                okButtonProps={{ style: { backgroundColor: '#2963ad', color: 'white', border: 'none' } }} // Styling for the "OK" button

                onCancel={handleCancel}>
                <h3 style={{ color: '#2963ad', fontWeight: 'bold' }}>Date Filter </h3>
                <DatePicker
                    value={selectedDate ? moment(selectedDate) : ''}

                    style={{ width: '100%' }}
                    onChange={handleDateChange}
                    format={"MM-DD-YYYY"}
                />
            </Modal>
            <Modal
                title={

                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Work Completed Table</span>
                            <div style={{ display: 'flex', alignItems: 'center' }}>

                                <Button
                                    onClick={handleExportDeleteTask}
                                    // disabled={!showExportButton} 
                                    style={{ marginRight: '10px', background: '#2863ad', color: "white", borderRadius: '10px', marginLeft: '15px' }}
                                >
                                    Download</Button>
                                {/* )} */}


                            </div>
                        </div>
                    </div>

                } className='ModalWidth' style={{ width: '100% !important' }} visible={isSecondModalOpen} onOk={handleSecondModalOk} onCancel={handleSecondModalCancel} footer={null}>
                <Table
                    dataSource={tableData}
                    columns={yourColumns}
                    pagination={pagination}
                    onChange={(pagination) => setPagination(pagination)}
                />
            </Modal>
            <Modal

                title={<span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Part Info</span>}

                visible={modalVisible}
                onCancel={handleModalClose}
                footer={null}
            >
                {/* Modal content goes here */}
                <Form
                    form={form}
                    name="basic"
                    labelCol={{
                        span: 7,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    style={{
                        maxWidth: 800,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    autoComplete="off"
                    labelAlign='left'

                >
                    <Form.Item
                        label="Part Type"
                        name='PartType'
                        rules={[
                            {
                                required: true,
                                message: 'Please input your username!',
                            },
                        ]}
                    >
                        <Input disabled style={{ color: 'black' }} />
                    </Form.Item>
                    <Form.Item
                        label="Part Number"
                        name='PartNbr'
                        rules={[
                            {
                                required: true,
                                message: 'Please input your username!',
                            },
                        ]}
                    >
                        <Input disabled style={{ color: 'black' }} />
                    </Form.Item>
                    <Form.Item
                        label="Part Serial Number"
                        name='PartSerialNbr'
                        rules={[
                            {
                                required: true,
                                message: 'Please input your username!',
                            },
                        ]}
                    >
                        <Input disabled style={{ color: 'black' }} />
                    </Form.Item>
                </Form>
            </Modal>


            {/*  Modal Work Order Completed Updated */}
            <Modal
                title={<span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Date Work Scheduled</span>}


                visible={isModalOpenCompleted}
                onOk={() => {
                    resetCheckboxStates();
                    handleOkCompleted();
                }}
                okButtonProps={{ style: { backgroundColor: '#2963ad', color: 'white', border: 'none' } }}
                // onCancel={handleCancelCompleted}
                onCancel={() => {
                    resetCheckboxStates();
                    handleCancelCompleted();
                }}
            >
                <h3 style={{ color: '#2963ad', fontWeight: 'bold' }}>Date Filter </h3>
                <DatePicker
                    value={selectedDate ? moment(selectedDate) : ''}


                    style={{ width: '100%' }} onChange={handleDateChange} format={"MM-DD-YYYY"} />

                <Checkbox
                    id="taskCheckbox"
                    style={{ marginTop: '10px' }}
                    checked={isTaskChecked}
                    onChange={(e) => setIsTaskChecked(e.target.checked)}
                >
                    By Task
                </Checkbox>
                <Checkbox
                    id="statusCheckbox"
                    checked={isStatusChecked}
                    onChange={(e) => setIsStatusChecked(e.target.checked)}
                >
                    Include Compl Pending Review
                </Checkbox>

            </Modal>


            <Modal
                title={

                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Scheduled Repairs</span>
                            <div style={{ display: 'flex', alignItems: 'center' }}>

                                <Button
                                    onClick={handleExportDeleteTaskUpdated}
                                    style={{ marginRight: '10px', background: '#2863ad', color: "white", borderRadius: '10px', marginLeft: '15px' }}
                                >
                                    Download
                                </Button>
                            </div>
                        </div>
                    </div>

                } className='ModalWidth' style={{ width: '100% !important' }} visible={isScheduleRepairsModalOpen} onOk={handleScheduleRepairsModalOk} onCancel={handleScheduleRepairsModalCancel} footer={null}>
                <Table dataSource={tableDataUpdated} columns={yourColumnsModal2}
                    pagination={pagination}
                    onChange={(pagination) => setPagination(pagination)}
                />
            </Modal>

        </PageLayout>
    )
}

export default LocomotiveWorkOrders